import { Column, Text } from 'farmhub-ui-core';

import { IconWrapper, Wrapper } from './styles';

type RedirectItemProps = {
  icon: React.ReactNode;
  title: string;
  description?: string;
  color: string;
  hoverBackground: string;
  route: string;
};

const RedirectItem = ({
  icon,
  title,
  description,
  color,
  hoverBackground,
  route,
}: RedirectItemProps): React.ReactElement => (
  <Wrapper
    hoverBackground={hoverBackground}
    iconColor={color}
    onClick={() => {
      window.open(route);
    }}
  >
    <IconWrapper iconColor={color}>{icon}</IconWrapper>

    <Column styles={{ gap: 0 }}>
      <Text
        color="primary"
        styles={{ fontSize: '13px !important' }}
        weight="extraBold"
      >
        {title}
      </Text>
      {description && (
        <Text color="secondary" size="xxs">
          {description}
        </Text>
      )}
    </Column>
  </Wrapper>
);
export default RedirectItem;
